import React, { useEffect, useState } from 'react';
import { AiOutlineLogout } from 'react-icons/ai';
import { useParams, useNavigate } from 'react-router-dom';
import { GoogleLogout } from 'react-google-login';

import { userCreatedPinsQuery, userQuery, userSavedPinsQuery } from '../utils/data';
import { client } from '../client';
import MasonryLayout from './MasonryLayout';
import Spinner from './Spinner';

//getting Random Images
const randomImg = "https://source.unsplash.com/1600x900/?nature,photography,technology"

const activeBtnStyles = 'bg-rose-600 text-white font-bold p-2 rounded-full w-20 outline-none';
const notActiveBtnStyles = 'bg-primary mr-4 text-sky-400 font-bold p-2 rounded-full w-20 outline-none';

const UserProfile = () => {
    const [user, setUser] = useState(null)
    const [text, setText] = useState('Created')
    const [activeBtn, setActiveBtn] = useState('created')
    const [pins, setPins] = useState()

    const navigate = useNavigate()

    //getting the user_Id from the url 
    const { userId } = useParams()

    //getting the user data
    const User = localStorage.getItem('user') !== 'undefined' ? JSON.parse(localStorage.getItem('user')) : localStorage.clear()


    //Getting the initial data
    useEffect(() => {
        const query = userQuery(userId)

        client.fetch(query)
            .then((data) => {
                setUser(data[0])
            })
    }, [userId])

    //handles the saved and created post 
    useEffect(() => {
        if (text === 'Created') {

            const createdPinsQuery = userCreatedPinsQuery(userId)

            client.fetch(createdPinsQuery)
                .then((data) => {
                    setPins(data)
                })
        } else {
            const savedPinsQuery = userSavedPinsQuery(userId)

            client.fetch(savedPinsQuery)
                .then((data) => {
                    setPins(data)
                })
        }

    }, [text, userId])

    //if the logout is success
    const logout = () => {
        localStorage.clear()

        navigate('/login')
    }

    //Loader 
    if (!user) return <Spinner message="Loading Powlli profile" />;

    return (
        <div className="relative pb-2 h-full justify-center items-center">
            <div className="flex flex-col pb-5">
                <div className="relative flex flex-col mb-7">
                    <div className="flex flex-col justify-center items-center">
                        <img
                            className=" w-full h-370 2xl:h-510 shadow-lg object-cover"
                            src={randomImg}
                            alt="user-pic"
                        />
                        <img
                            className="rounded-full w-20 h-20 -mt-10 shadow-xl object-cover"
                            src={user.image}
                            alt="user-pic"
                        />
                    </div>
                    <h1 className="text-gray-500 font-semibold text-3xl text-center mt-3">
                        {user.userName}
                    </h1>
                    {/* Logout  */}
                    <div className="absolute top-0 z-1 right-0 p-2">
                        {userId === User.googleId && (
                            <GoogleLogout
                                clientId={`${process.env.REACT_APP_GOOGLE_API_TOKEN}`}
                                render={(renderProps) => (
                                    <button
                                        type="button"
                                        className="bg-white p-2 rounded-full cursor-pointer outline-none shadow-md"
                                        onClick={renderProps.onClick}
                                        disabled={renderProps.disabled}
                                    >
                                        <AiOutlineLogout color="red" fontSize={21} />
                                    </button>
                                )}
                                onLogoutSuccess={logout}
                                cookiePolicy="single_host_origin"
                            />
                        )}
                    </div>
                </div>
                {/* Created and Saved Btn */}
                <div className="text-center mb-7">
                    <button
                        type="button"
                        onClick={(e) => {
                            //getting the text value from the button
                            setText(e.target.textContext)
                            setActiveBtn('created')
                        }}
                        className={`${activeBtn === 'created' ? activeBtnStyles : notActiveBtnStyles}`
                        }
                    >
                        Created
                    </button>
                    <button
                        type="button"
                        onClick={(e) => {
                            //getting the text value from the button
                            setText(e.target.textContext)
                            setActiveBtn('saved')
                        }}
                        className={`${activeBtn === 'saved' ? activeBtnStyles : notActiveBtnStyles}`
                        }
                    >
                        Saved
                    </button>
                </div>
                {/* render the saved and created pins */}
                {pins?.length ? (
                    <div className="px-2">
                        <MasonryLayout pins={pins} />
                    </div>
                ) : (
                    <div className="flex justify-center items-center w-full mt-2">
                        No Powllis saved
                    </div>
                )}

            </div >
        </div >
    )
}

export default UserProfile
